import { render, staticRenderFns } from "./ForumNavbar.vue?vue&type=template&id=f5724642&"
import script from "./ForumNavbar.vue?vue&type=script&lang=js&"
export * from "./ForumNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports